"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _Alert = require("b2b-components/theme/components/Alert");
var _DataTable = require("b2b-components/theme/components/DataTable");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _dataMappers = require("../../utils/dataMappers");
require("./TooltipContent.scss");
const TooltipContent = _ref => {
  let {
    className,
    stockCount,
    quantityOrdered,
    isSpecialOrder,
    text,
    directDelivery
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-StockCountTooltip', className);
  const isReadyForShipment = stockCount > 0;
  const displayQuantityOrdered = !!(Array.isArray(quantityOrdered) && quantityOrdered.length);
  const alertStyleType = isReadyForShipment ? _Alert.ALERT_STYLE_TYPE.success : _Alert.ALERT_STYLE_TYPE.warning;
  let alertMessage = /*#__PURE__*/_react.default.createElement("span", null, text.notReadyForShipment);
  if (isReadyForShipment) {
    alertMessage = directDelivery ? /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: text.readyForDirectDelivery
      }
    }) : /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: text.readyForShipment
      }
    });
  }
  const unknownDateOrders = [];
  const knownDateOrders = displayQuantityOrdered && quantityOrdered?.reduce((orders, order) => {
    if (order.deliveryDate) {
      orders.push(order);
    } else {
      unknownDateOrders.push({
        ...order,
        deliveryDate: text.unknownDeliveryDate
      });
    }
    return orders;
  }, []) || [];
  const transformedQuantityOrdered = [...knownDateOrders, ...unknownDateOrders].map(_dataMappers.transformQuantityOrderedToDataTable);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, isSpecialOrder && stockCount <= 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: 'cds-StockCountTooltip-SpecialOrder'
  }, text.specialOrder.explanation), (!isSpecialOrder || isSpecialOrder && stockCount > 0) && /*#__PURE__*/_react.default.createElement(_Alert.Alert, {
    displayType: _Alert.ALERT_DISPLAY_TYPE.text,
    styleType: alertStyleType,
    className: 'cds-StockCountTooltip-Alert'
  }, alertMessage), directDelivery && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-StockCountTooltip-DirectDeliveryInfo"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-StockCountTooltip-DirectDeliveryInfo-Single"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-StockCount-DirectDeliveryIcon",
    name: _Icon.ICON_NAME.packagePlusOutline
  }), " ", text.deliveryInfoPackage), /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-StockCountTooltip-DirectDeliveryInfo-Single"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-StockCount-DirectDeliveryIcon",
    name: _Icon.ICON_NAME.deliveryClockOutline
  }), " ", text.deliveryInfoTime)), !isSpecialOrder && displayQuantityOrdered && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: 'cds-StockCountTooltip-Title'
  }, text.deliveryDates), /*#__PURE__*/_react.default.createElement(_DataTable.DataTable, {
    header: [{
      value: text.date
    }, {
      value: text.orderedQuantity
    }],
    rows: transformedQuantityOrdered,
    className: 'cds-StockCountTable'
  })));
};
exports.TooltipContent = TooltipContent;
//# sourceMappingURL=TooltipContent.js.map